import { Expose, Transform, Type } from 'class-transformer';

import { Model } from './model';
import { RateReasonsWithComment } from './rate-reasons-with-comment-model';

export class ReviewersReviewsReport extends Model {
  @Expose() studentId: string;
  @Expose() studentName: string;
  @Expose() teacherId: string;
  @Expose() teacherName: string;
  @Expose() reviewReasons: string;
  @Expose() reviewId: string;
  @Expose()
  @Transform(({ value }) => (value ? value.toFixed(2) : null))
   rate: string;
  @Expose() comment: string;
  @Expose() adminApprove: boolean;
  @Expose()
  @Transform(({ value }) => (value ? new Date(value) : null))
  date: Date | null;
  @Expose()
  @Type(() => RateReasonsWithComment)
  reasonsWithCommentOrdered: RateReasonsWithComment;
}
